import { constants } from '@nhl/formatter-utilities';
import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchMediaAvailabilitiesData = args => {
    const { date } = args;
    const gameDateLower = date.startOf('day').format(constants.SQL_DATE_FORMAT);
    const gameDateUpper = date.endOf('day').format(constants.SQL_DATE_FORMAT);

    return doDefaultFetch(
        `/site/api/mediaAvailabilityDetail` +
        `?cayenneExp=date='${date.format(constants.DATE_FORMAT)}'` +
        `&include=${JSON.stringify([
            'team',
            'team.logos',
            {
                path: 'team.homeGames',
                cayenneExp: `gameDate >= '${gameDateLower}' and gameDate <= '${gameDateUpper}'`,
            },
            {
                path: 'team.awayGames',
                cayenneExp: `gameDate >= '${gameDateLower}' and gameDate <= '${gameDateUpper}'`,
            },
            'team.homeGames.season',
            'team.homeGames.visitingTeam',
            'team.homeGames.visitingTeam.logos',
            'team.homeGames.gameScheduleState.id',
            'team.homeGames.homeTeam',
            'team.homeGames.homeTeam.logos',
            'team.awayGames.season',
            'team.awayGames.visitingTeam',
            'team.awayGames.visitingTeam.logos',
            'team.awayGames.homeTeam',
            'team.awayGames.homeTeam.logos',
            'team.awayGames.gameScheduleState.id',
        ])}`,
        /*
        Currently cross-db relationship can't be used in sorting, so for now sorting will be done in operations.
        + `&sort=${JSON.stringify([{
            property: 'team.fullName',
            direction: 'ASC',
        }, {
            property: 'time',
            direction: 'ASC',
        }])}`
         */
        args
    );
};

const fetchMediaAvailabilityMinimumDate = () => {
    return doDefaultFetch('/site/api/mediaAvailabilityDetail/minimumDate');
};

export default {
    fetchMediaAvailabilitiesData,
    fetchMediaAvailabilityMinimumDate,
};